import { useContext } from 'react'
import { BossFilterContext } from 'providers/BossFilterProvider'

export function useBossFilter() {
  const context = useContext(BossFilterContext)
  return {
    bosses: context?.bosses ?? [],
    selectedBossId: context?.enabled ? context?.selectedBossId : undefined,
    setSelectedBossId: context?.setSelectedBossId ?? (() => {}),
    myIpPersonId: context?.myIpPersonId ?? null,
    loading: context?.loading ?? false,
    enabled: context?.enabled ?? false,
  }
}
